angular.module('leanlaw').directive('llSort', [function () {
  return {
    restrict: 'A',
    transclude: true,
    template: "<span ng-click='sort()'><span ng-transclude></span>" + "<span ng-show='sortField==llSort'>&nbsp;<span class='no-print fa' ng-class=\"{'fa-caret-down':sortDirection, 'fa-caret-up':!sortDirection}\"></span></span></span>",
    scope: {
      llSort: '=',
      sortField: '=',
      sortDirection: '='
    },
    link: function (scope, element, attr) {
      scope.sort = function () {
        if (scope.sortField === scope.llSort) {
          scope.sortDirection = !scope.sortDirection;
        } else {
          scope.sortField = scope.llSort;
        }
      };
    }
  };
}]);